import { Component, OnInit, HostListener } from '@angular/core';
import Player from '@vimeo/player';
import { ActivatedRoute, Router } from '@angular/router';
import { LocationStrategy } from '@angular/common';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-video-player',
  templateUrl: './video-player.component.html',
  styleUrls: ['./video-player.component.css']
})
export class VideoPlayerComponent implements OnInit {

  hasChanges:any = 'a';
  idVideo: number;
  gledanjaBroj: string;
  dozvoljenBroj: string;
  naslovVidea: string;
  Url: any;

  @HostListener('window:beforeunload', ['$event'])
  doSomething($event) {
    //  alert($event);
     if(this.hasChanges) $event.returnValue = true;
  }

  constructor(
    private location: LocationStrategy,
    private _route: ActivatedRoute,
    private _sanitizer:DomSanitizer
    ) {
    history.pushState(null, null, window.location.href);  
    this.location.onPopState(() => {
      alert('Nije moguće vratiti se na prethodni ekran! Ako ste pogledali video do kraja zatvorite tab web preglednika.')
      history.pushState(null, null, window.location.href);
    });  
   }

  ngOnInit() {
    this.idVideo = this._route.snapshot.params.v; 
    this.gledanjaBroj = this._route.snapshot.params.g; 
    this.dozvoljenBroj = this._route.snapshot.params.d; 
    this.naslovVidea = this._route.snapshot.params.n; 
    this.Url = this._sanitizer.bypassSecurityTrustResourceUrl("https://player.vimeo.com/video/"+this.idVideo);
    console.log(this.Url);
  //   const player = new Player('handstick', {
  //     id: this.idVideo,
  //     width: 640,
  //     playsinline: true,
  //     controls: true,
  //     color: '#fbca08'
  // });
   
  // player.on('play', function() {
  //     console.log('played the video!');
  // });
  }

}


// WEBPACK FOOTER //
// C:/Users/TomislavS/Projekti/31-Holspico-VirtualnaUcionica/VirtualnaUcionica-Web/src/app/pages/vimeo/video-player/video-player.component.ts